// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zIlo","rootMobile":"styles_rootMobile__2lrnl"};